import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import "./index.css";

createApp(App).mount("#app");

if ("serviceWorker" in navigator) {
	navigator.serviceWorker
		.register("/service-worker.js")
		.then((registration) => {
			console.log("Service Worker registered:", registration);
		})
		.catch((error) => {
			console.log("Service Worker registration failed:", error);
		});
}
